var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pvp-tooltip',{staticClass:"trusted",class:{ enabled: _vm.isTrusted }},[_c('Icon',{attrs:{"name":_vm.isTrusted ? 'trusted' : 'untrusted'}}),_c('template',{slot:"tooltip"},[_vm._v(_vm._s(_vm.tooltip))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }